module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('froala', {
    attrs: {
      "id": "editor",
      "tag": 'textarea',
      "config": _vm.config,
      "value": _vm.answer
    },
    on: {
      "input": _vm.changeContent
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-257ce1f8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/itemFloara.vue
// module id = 1516
// module chunks = 0